// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyBqx05ZzQSCbG1-XWf9gXCY9Ra7x0G5Y7I',
    appId: '1:1057173118507:web:68aa80dc4474183ed5146e',
    authDomain: 'hort361-manager.firebaseapp.com',
    measurementId: 'G-BD5SJ936FY',
    messagingSenderId: '1057173118507',
    projectId: 'hort361-manager',
    storageBucket: 'hort361-manager.appspot.com',
  },
  production: false,
  useEmulators: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
